import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import theLocalStorageUtils from './LocalStorageUtils';
import { CallingProductId } from '@/constants/CallingProductIds';

export default {
    isTotal(): boolean {
        const productId = theLocalStorageUtils.get(LocalStorageKeys.callingProductId);
        return equals(CallingProductId.Total, productId ?? 0);
    },

    isNone(): boolean {
        const productId = theLocalStorageUtils.get(LocalStorageKeys.callingProductId);
        return equals(CallingProductId.None, productId ?? 0);
    },

    getUpdateNumber(): number {
        const updateNumber = theLocalStorageUtils.get(LocalStorageKeys.totalUpdateNumber);
        return updateNumber ? Number(updateNumber) : 0;
    }
};

function equals(productId: CallingProductId, value: number | string): boolean {
    if (value) {
        return typeof value === 'number' ? value === productId : Number(value) === productId;
    }

    return productId === CallingProductId.None;
}
